module.exports = __webpack_public_path__ + "img/kefu.e2af804c.png";